<template>
    <LazyContentEdition v-if="isEditable" :content="content" :human-id="humanId" :type="type" />
    <div v-else class="content_styles" v-html="content"></div>
</template>

<script setup lang="ts">
    import {LazyContentEdition} from '#components';

    interface Props {
        content: string;
        readonly?: boolean;
        humanId: string;
        type: string;
    }

    const {content, readonly = false, humanId, type} = defineProps<Props>();

    const isEditable = !readonly;
</script>

<style lang="scss">
    .content_styles {
        h2,
        h3,
        h4 {
            margin-top: var(--joy-core-spacing-8);
            margin-bottom: var(--joy-core-spacing-4);
        }
        h2 {
            font-size: var(--joy-font-size-primary-800);
            color: var(--joy-color-secondary-90);
            font-family: var(--joy-font-weight-bold);
        }

        h3 {
            font-size: var(--joy-font-size-primary-600);
            font-family: var(--joy-font-weight-bold);
            color: var(--joy-color-primary-90);
            margin-top: var(--joy-core-spacing-8);
        }

        h4 {
            margin-bottom: 20px;
            font-size: var(--joy-font-size-primary-400);
            font-family: var(--joy-font-weight-bold);
            margin-bottom: var(--joy-core-spacing-3);
        }
        table {
            width: 100%;
            table-layout: fixed;

            td,
            th {
                border: 1px solid var(--joy-color-neutral-40);
                padding: 10px;
                word-break: break-word;
            }

            th {
                font-weight: var(--joy-font-weight-bold);
                background-color: var(--joy-color-neutral-30);
            }
        }
        a {
            color: var(--joy-color-secondary-30);
            text-decoration: none;
            font-weight: var(--joy-font-weight-bold);
            &:hover {
                text-decoration: underline;
                color: var(--joy-color-secondary-90);
            }
        }
    }
</style>
